import {
  GetFiltersCollaboratorsResponse,
  GetFiltersPotentialMatrixResponse,
  GetFiltersCoursesResponse,
  GetFiltersCareerManagersResponse,
  GetFiltersConfigCollaboratorsResponse,
  GetFiltersCollaboratorHistoryProjectsResponse,
  GetFiltersCertificationsResponse,
  TechSkillsPropertyNameResponse,
  OrganizationPropertyNameResponse,
} from "../../../types/api/filters.type";
import { QueryParam } from "../../../types/api/generic.type";
import {
  OrganizationPropertyEnum,
  TechSkillPropertyEnum,
} from "../../../types/AppTypes";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const FiltersService = {
  async listForCollaborators(
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetFiltersCollaboratorsResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";

    const response = await httpClient.get<GetFiltersCollaboratorsResponse>(
      `v1/filters/collaborators${params}`,
      { signal },
    );
    return response;
  },
  async listForPotentialMatrix(): Promise<GetFiltersPotentialMatrixResponse> {
    const response = await httpClient.get<GetFiltersPotentialMatrixResponse>(
      "v1/filters/potential-matrix",
    );
    return response;
  },
  async listForCourses(): Promise<GetFiltersCoursesResponse> {
    const response =
      await httpClient.get<GetFiltersCoursesResponse>("v1/filters/courses");
    return response;
  },
  async listForCertifications(): Promise<GetFiltersCertificationsResponse> {
    const response = await httpClient.get<GetFiltersCertificationsResponse>(
      "v1/filters/certifications",
    );
    return response;
  },
  async listForCareerManagers(): Promise<GetFiltersCareerManagersResponse> {
    const response = await httpClient.get<GetFiltersCareerManagersResponse>(
      "v1/filters/career-managers",
    );
    return response;
  },
  async listForCollaboratorHistoryProjects(
    collaboratorId: number,
  ): Promise<GetFiltersCollaboratorHistoryProjectsResponse> {
    const response =
      await httpClient.get<GetFiltersCollaboratorHistoryProjectsResponse>(
        `v1/filters/collaborators/${collaboratorId}/history/projects`,
      );
    return response;
  },
  async listForConfigCollaborators(): Promise<GetFiltersConfigCollaboratorsResponse> {
    const response =
      await httpClient.get<GetFiltersConfigCollaboratorsResponse>(
        "v1/filters/config/collaborators",
      );
    return response;
  },
  async listTechSkillsProperty(
    propertyName: TechSkillPropertyEnum,
    pageSize: number,
    pageNumber: number,
    params?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<TechSkillsPropertyNameResponse> {
    const queryString = params ? createQueryParamString(params) : "";
    const response = await httpClient.get<TechSkillsPropertyNameResponse>(
      `v1/filters/tech-skills/${propertyName}?pageSize=${pageSize}&pageNumber=${pageNumber}${queryString}`,
      { signal },
    );
    return response;
  },
  async listOrganizationProperty(
    propertyName: OrganizationPropertyEnum,
    params?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<OrganizationPropertyNameResponse> {
    const queryString = params ? createQueryParamString(params, true) : "";

    const response = await httpClient.get<OrganizationPropertyNameResponse>(
      `v1/filters/org/${propertyName}${queryString}`,
      { signal },
    );
    return response;
  },
};

export default FiltersService;
